// src/components/Configurator/renderers/RadiatorRenderer.jsx
import React from "react";
import { SELECTED_ELEMENT_COLOR, defaultObjectSizes, OBJECT_TYPES, DRAWING_RADIATOR_FILL_COLOR, DRAWING_RADIATOR_STROKE_COLOR } from "../configuratorConstants";

const RadiatorRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness, // in meters
  placementSideFactor, // Should be 1 or -1
}) => {
  const radiatorDefaults = defaultObjectSizes[OBJECT_TYPES.RADIATOR];
  const elementVisualWidthM = element.width || radiatorDefaults.width;
  const elementVisualHeightM = element.height || radiatorDefaults.height; // This is the height on the wall
  const elementPlanDepthM = element.depth || radiatorDefaults.depth || 0.1; // Depth from the wall

  const elementVisualWidthPx = elementVisualWidthM * scale;
  const elementVisualHeightPx_onPlan = elementPlanDepthM * scale; // On plan, we see its depth
  const wallThicknessPx = wallThickness * scale;

  // Position the center of the radiator's depth relative to the wall surface
  const yOffset = placementSideFactor * ((wallThicknessPx / 2) + (elementPlanDepthM / 2));

  const rectStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : DRAWING_RADIATOR_FILL_COLOR,
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : DRAWING_RADIATOR_STROKE_COLOR,
    strokeWidth: isSelected ? 1.5 / (scale / 50) : 1 / (scale / 50),
  };

  // If placementSideFactor is 1, flip the "front" (which is just the rect for now)
  const groupTransform = placementSideFactor === 1 ? "scale(1, -1)" : "";
  // Since it's a rect, scale(1,-1) won't visually change it unless y and height are asymmetric or it has text/children.
  // But it's good for consistency if it were an SVG.

  return (
    <g transform={`translate(0, ${yOffset})`}>
      <g transform={groupTransform}>
        <rect
          x={-elementVisualWidthPx / 2}
          y={-elementVisualHeightPx_onPlan / 2} // Center the depth on the plan
          width={elementVisualWidthPx}
          height={elementVisualHeightPx_onPlan} // Show its depth on the plan
          style={rectStyle}
        />
      </g>
    </g>
  );
};

export default React.memo(RadiatorRenderer);